export const COLORS = {
    bg0: "#0a0a0a",
    bg1: "#121215",
    bg2: "#1c1c1e",
    fg0: "#ffffff",
    fg1: "#a1a1aa",
    fg2: "#71717a",
    line: "rgba(255,255,255,0.08)",
    volt: "#007aff",
    blaze: "#ff3b30",
    signal: "#ffcc00",
    green: "#34c759",
};

export const POSITION_COLORS = {
    QB: "#ffcc00",
    RB: "#007aff",
    WR: "#34c759",
    TE: "#ff3b30",
};

export const CONFERENCE_COLORS = {
    SEC: "#ffcc00",
    "Big Ten": "#007aff",
    "Big 12": "#ff3b30",
    ACC: "#34c759",
    "Pac-12": "#a78bfa",
};

export const ARCHETYPE_COLORS = {
    "Star Winners": "#007aff",
    "Balanced Winners": "#34c759",
    "Concentrated Strugglers": "#ff3b30",
    "Balanced Strugglers": "#ffcc00",
};
